import ToastCustom from "shared/components/ToastCustom";
import {
  LOCAL_STORAGE_CARTS,
  LOCAL_STORAGE_INFORMATION_CART,
} from "shared/Constants";
import {
  FETCH_LIST_CART_IN_LOCAL_STORAGE_SUCCESS,
  FETCH_LIST_CART_SUCCESS,
} from "../ActionTypes/CartActionTypes";
import { activeProgress, disableProgress } from "./ProgressActionCreators";
import cartApi from "../../api/CartApi";

export const fetchListCartInLocalStorageSuccess = () => {
  return {
    type: FETCH_LIST_CART_IN_LOCAL_STORAGE_SUCCESS,
  };
};

export const fetchAddInformationCartInLocalStorage = (data) => {
  return (dispatch) => {
    localStorage.setItem(LOCAL_STORAGE_INFORMATION_CART, JSON.stringify(data));
  };
};

export const fetchAddToCartInLocalStorage = (
  id,
  title,
  priceDiscount,
  imgPath
) => {
  return (dispatch) => {
    const cartsInLocalStore = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_CARTS)
    );
    let newCartsInLocalStore = [];

    if (!cartsInLocalStore) {
      newCartsInLocalStore = [
        { id: id, title, priceDiscount, imgPath, count: 1 },
      ];
    } else {
      let isExist = false;

      cartsInLocalStore.forEach((item) => {
        if (item.id === id) {
          item.count++;
          isExist = true;
          return;
        }
      });
      if (!isExist) {
        cartsInLocalStore.push({
          id: id,
          title,
          priceDiscount,
          imgPath,
          count: 1,
        });
      }

      newCartsInLocalStore = [...cartsInLocalStore];
    }
    ToastCustom.success("Đã thêm sản phẩm vào giỏ hàng");
    localStorage.setItem(
      LOCAL_STORAGE_CARTS,
      JSON.stringify(newCartsInLocalStore)
    );

    dispatch(fetchListCartInLocalStorageSuccess());
  };
};

export const fetchDeleteToCartInLocalStorageByID = (id) => {
  return (dispatch) => {
    let cartsFromLocalStorage = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_CARTS)
    );

    const newCarts = cartsFromLocalStorage.filter((item) => {
      return item.id !== id;
    });

    ToastCustom.warning("Đã xóa sản phẩm ra giỏ hàng");
    localStorage.setItem(LOCAL_STORAGE_CARTS, JSON.stringify(newCarts));

    dispatch(fetchListCartInLocalStorageSuccess());
  };
};

export const fetchInCreateCountByID = (id) => {
  return (dispatch) => {
    let cartsFromLocalStorage = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_CARTS)
    );

    cartsFromLocalStorage.map((item) => {
      if (item.id === id) {
        item.count++;
      }
      return item;
    });

    localStorage.setItem(
      LOCAL_STORAGE_CARTS,
      JSON.stringify(cartsFromLocalStorage)
    );
    dispatch(fetchListCartInLocalStorageSuccess());
  };
};

export const fetchDeCreateCountByID = (id) => {
  return (dispatch) => {
    let cartsFromLocalStorage = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_CARTS)
    );

    cartsFromLocalStorage.map((item) => {
      if (item.id === id) {
        if (item.count > 1) {
          item.count--;
        }
      }
      return item;
    });

    localStorage.setItem(
      LOCAL_STORAGE_CARTS,
      JSON.stringify(cartsFromLocalStorage)
    );
    dispatch(fetchListCartInLocalStorageSuccess());
  };
};

export const fetchPaidOfCartOnline = (idCart) => {
  return (dispatch) => {
    dispatch(activeProgress());
    cartApi
      .setPaid(idCart)
      .then(
        (res) => {},
        (err) => {}
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchPaginationCartRequest = (index, size, keySort) => {
  return (dispatch) => {
    dispatch(activeProgress());

    return cartApi
      .paginate(size, index, keySort)
      .then(
        (res) => {
          dispatch(fetchListCartSuccess(res.body));
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchPatchToggleStatusPaymentCart = (id) => {
  return (dispatch) => {
    dispatch(activeProgress());

    return cartApi
      .toggleStatusPayment(id)
      .then(
        (res) => {},
        (err) => {}
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchClearCartInLocalStorage = () => {
  return (dispatch) => {
    localStorage.removeItem(LOCAL_STORAGE_CARTS);
    dispatch(fetchListCartInLocalStorageSuccess());
  };
};

export const fetchListCartSuccess = (data) => {
  return {
    type: FETCH_LIST_CART_SUCCESS,
    payload: data,
  };
};
